import React, { Component } from "react";
class EmployeeForm extends Component {
  state = {
    employee: {},
  };
  componentDidMount = () => {
    this.setState({
      employee: this.props.employee,
    });
  };

  render() {
    const { employee } = this.state;

    return (
      <section
        className="card"
        style={{
          padding: 10,
        }}
      >
        <div className="col-md-8">
          <div className="form-group">
            <label>{"Nama Lengkap"} *</label>
            <input
              className="form-control"
              disabled
              required
              value={employee.name}
            />
          </div>
          <div className="form-group">
            <label>{"Nama Panggilan"} *</label>
            <input
              className="form-control"
              disabled
              required
              value={employee.nickName}
            />
          </div>
          <div className="form-group">
            <label>{"Gelar Depan"}</label>
            <input
              className="form-control"
              disabled
              value={employee.titleAhead}
            />
          </div>
          <div className="form-group">
            <label>{"Gelar Belakang"}</label>
            <input
              className="form-control"
              disabled
              value={employee.titleBehind}
            />
          </div>
          <div className="form-group">
            <label>{"Jenis Kelamin"} *</label>
            <select
              className="form-control"
              disabled
              required
              value={employee.gender}
            >
              <option value="Laki-laki">{"Laki-laki"}</option>
              <option value="Perempuan">{"Perempuan"}</option>
            </select>
          </div>
          <div className="form-group">
            <label>{"NRP / NIP"} *</label>
            <input
              className="form-control"
              disabled
              required
              value={employee.regNumber}
            />
          </div>
          <div className="form-group">
            <label>{"NUPTK"}</label>
            <input className="form-control" disabled value={employee.nuptk} />
          </div>
          <div className="form-group">
            <label>{"Status"} *</label>
            <select
              className="form-control"
              disabled
              required
              value={employee.status}
            >
              <option value="" disabled>
                {"Plih status"}
              </option>
              <option value="Aktif">{"Aktif"}</option>
              <option value="Non Aktif">{"Non Aktif"}</option>
            </select>
          </div>
          <div className="form-group">
            <label>{"Nomor HP / Telepon"} *</label>
            <input
              required
              className="form-control"
              disabled
              value={employee.phoneNumber}
            />
          </div>
          <div className="form-group">
            <label>{"Nomor Whatsapp"}</label>
            <input
              required
              className="form-control"
              disabled
              value={employee.noWA}
            />
          </div>
          <div className="form-group">
            <label>{"Alamat Email"}</label>
            <input
              type="email"
              className="form-control"
              disabled
              value={employee.email}
            />
          </div>
          <div className="form-group">
            <label>{"Nomor Telepon Untuk Keadaan Darurat"}</label>
            <input
              className="form-control"
              disabled
              value={employee.emergencyPhoneNumber}
            />
          </div>

          <hr />

          <div className="form-group">
            <label>{"Tanggal Masuk"}</label>
            <input
              type="date"
              className="form-control"
              disabled
              value={employee.workEntryDate}
            />
          </div>
          <div className="form-group">
            <label>{"Tahun Pendidikan"}</label>
            <input
              className="form-control"
              disabled
              type="number"
              style={{ maxWidth: 150 }}
              value={employee.educationYear}
            />
          </div>
          <div className="form-group">
            <label>{"Nomor SK Kepegawaian"}</label>
            <input
              className="form-control"
              disabled
              value={employee.decreeNumber}
            />
          </div>

          <hr />

          <div className="form-group">
            <label>{"Kota Lahir"}</label>
            <input
              className="form-control"
              disabled
              value={employee.hometown}
            />
          </div>
          <div className="form-group">
            <label>{"Tanggal Lahir"}</label>
            <input
              type="date"
              className="form-control"
              disabled
              value={employee.birthDate}
            />
          </div>
          <div className="form-group">
            <label>{"Alamat Tempat Tinggal"}</label>
            <textarea
              className="form-control"
              disabled
              value={employee.address}
            />
          </div>
          <div className="form-group">
            <label>{"Kota Tempat Tinggal"}</label>
            <input
              className="form-control"
              disabled
              value={employee.cityOfResidence}
            />
          </div>

          <hr />

          <div className="form-group">
            <label>{"Status Pernikahan"}</label>
            <select
              className="form-control"
              disabled
              value={employee.marriedStatus}
            >
              <option value="" disabled>
                {"Plih status pernikahan"}
              </option>
              <option value="Lajang">{"Lajang"}</option>
              <option value="Menikah">{"Menikah"}</option>
              <option value="Duda / Janda">{"Duda / Janda"}</option>
            </select>
          </div>
          <div className="form-group">
            <label>{"Agama"}</label>
            <select className="form-control" disabled value={employee.religion}>
              <option value="" disabled>
                {"Plih agama"}
              </option>
              <option value="Islam">{"Islam"}</option>
              <option value="Kristen">{"Kristen"}</option>
              <option value="Katolik">{"Katolik"}</option>
              <option value="Hindu">{"Hindu"}</option>
              <option value="Budha">{"Budha"}</option>
              <option value="Konghuchu">{"Konghuchu"}</option>
            </select>
          </div>
          <div className="form-group">
            <label>{"Bahasa Sehari-hari"}</label>
            <input
              className="form-control"
              disabled
              value={employee.language}
            />
          </div>
          <div className="form-group">
            <label>{"Berat Badan (kg)"}</label>
            <input className="form-control" disabled value={employee.weight} />
          </div>
          <div className="form-group">
            <label>{"Tinggi Badan (cm)"}</label>
            <input className="form-control" disabled value={employee.height} />
          </div>
          <div className="form-group">
            <label>{"Riwayat Penyakit"}</label>
            <textarea
              className="form-control"
              disabled
              value={employee.diseaseHistory}
            />
          </div>
          <div className="form-group">
            <label>{"Alergi Makanan"}</label>
            <textarea
              className="form-control"
              disabled
              value={employee.foodAllergies}
            />
          </div>
          <div className="form-group">
            <label>{"Alergi Minuman"}</label>
            <textarea
              className="form-control"
              disabled
              value={employee.beverageAllergies}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default EmployeeForm;
